// this is totally weird, but it allows us to avoid including a slot prop at all
// rather than including an undefined one, which makes a difference
export const maybeSlot = (slot?: string) => {
  const maybeSlotProp: { slot?: string } = {};
  if (slot) {
    maybeSlotProp.slot = slot;
  }
  return maybeSlotProp;
};
